import React, { Component } from "react";
import ImageOrInitial from "./ImageOrInitial";
import Logo_PDF from "../img/ico/black_pdf.png"
import { pdfjs, Document, Page } from 'react-pdf'


class PDFPreviewLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber:0,
      numPages:0,
    };
  }
  componentDidMount(){
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }
  
  showPDF = () =>{
    window.open(this.props.pdf.src);
  }

  setPage = (decrement) =>{
    var pageNumber = this.state.pageNumber;
    if(decrement) pageNumber--;
    else pageNumber++;

    if(pageNumber > -1 && pageNumber < this.state.numPages) 
      this.setState({pageNumber});
  }

  onDocumentLoadSuccess = ({numPages}) =>{
    this.setState({numPages});
  }
  render() {
    if(this.props.pdf?.base64String){
      return(

        <Document file={this.props.pdf.src} onLoadSuccess={this.onDocumentLoadSuccess}>
          <Page pageIndex={this.state.pageNumber} >
          </Page>
          <div className="pdfPreviewButtons">
            <button onClick={() => this.setPage(true)}>Prev</button>
            <span>Page {this.state.pageNumber+1} of {this.state.numPages}</span>
            <button onClick={() => this.setPage(false)} >Next</button>
          </div>
          
        </Document>
      )
    }
    return (
      <img src={this.props.pdf.src} className="card pdfPreviewLink"/>
    )
    return (
      <div className="card pdfPreviewLink" onClick={this.showPDF}>
        <img src={Logo_PDF}/>
        <div className="title">{this.props.pdf && this.props.pdf.name}</div>
        <div className="subtitle">View PDF</div>
      </div>
    );
  }
}
 
export default PDFPreviewLink;